import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CountriesRoutingModule } from './countries-routing.module';
import { CountriesDetailComponent } from './countries-detail/countries-detail.component';
import { CountriesListComponent } from './countries-list/countries-list.component';
import { CountriesService } from './countries.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    CountriesDetailComponent,
    CountriesListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CountriesRoutingModule,
    HttpClientModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    CardModule,
    FontAwesomeModule,
    ConfirmDialogModule,
    DropdownModule
  ],
  exports:[
    CountriesDetailComponent,
    CountriesListComponent
  ],
  providers:[
    CountriesService
  ]
})
export class CountriesModule { }
